"use server";

import { redirect } from "next/navigation";
import { createUser, authenticate, login, logout } from "@/lib/auth";

export type FormState = { error?: string } | undefined;

export async function signupAction(
  _prev: FormState,
  formData: FormData,
): Promise<FormState> {
  const email = String(formData.get("email") ?? "");
  const password = String(formData.get("password") ?? "");
  const name = String(formData.get("name") ?? "");
  const next = String(formData.get("next") ?? "/membership");

  if (!email || !password) return { error: "Email and password are required." };
  if (password.length < 8)
    return { error: "Use at least 8 characters for your password." };

  try {
    // Phone is collected (and required) during onboarding, not here: that's the
    // one path both email/password and Google sign-ups converge on, and Google
    // never returns a phone number.
    const user = await createUser({ email, password, name });
    await login(user.id);
  } catch (e) {
    return { error: e instanceof Error ? e.message : "Could not create account." };
  }
  // New accounts go through onboarding first; `next` is where they land after.
  redirect(`/onboarding?next=${encodeURIComponent(next)}`);
}

export async function loginAction(
  _prev: FormState,
  formData: FormData,
): Promise<FormState> {
  const email = String(formData.get("email") ?? "");
  const password = String(formData.get("password") ?? "");
  const next = String(formData.get("next") ?? "/");

  const user = await authenticate(email, password);
  if (!user) return { error: "Invalid email or password." };
  await login(user.id);
  redirect(next);
}

export async function logoutAction() {
  await logout();
  redirect("/");
}
